document.querySelector('.size_guide_modal_trigger').addEventListener('click', function () {
    document.querySelector('.size_guide_modal_wrapper').classList.add('is-open');
});

document.querySelector('.size_guide_modal_trigger_close').addEventListener('click', function () {
    document.querySelector('.size_guide_modal_wrapper').classList.remove('is-open');
});

// Close on background click
document.querySelector('.size_guide_modal_wrapper').addEventListener('click', function (e) {
    if (e.target === this) {
        this.classList.remove('is-open');
    }
});